import { UPDATE_CONTRIBUTE_INFO } from 'redux/types/Type'

export const updateContributeInfoAction = (payload) => ({
	type: UPDATE_CONTRIBUTE_INFO,
	payload,
})
